import BaseModel from './BaseModel'

export default class MailSujetModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      LIBELLE: ''
    }
    super(data, relation, fields)
  }
}
